import { render, staticRenderFns } from "./OrdersPage2.vue?vue&type=template&id=6a5a995d&scoped=true"
import script from "./OrdersPage2.vue?vue&type=script&lang=js"
export * from "./OrdersPage2.vue?vue&type=script&lang=js"
import style0 from "./OrdersPage2.vue?vue&type=style&index=0&id=6a5a995d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5a995d",
  null
  
)

export default component.exports